import {CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select} from '@material-ui/core';
import {WorkQueueItem} from 'ApplicationEntry/models/WorkQueueItem';
import * as AWDStatusActions from 'ApplicationEntry/ducks/AWDStatus';
import {isLoaded, isLoading, matchWorkType, WorkType} from 'ApplicationEntry/models/AWDStatus/WorkType';
import {StringUnion} from 'Core/models/EmptyString';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import './AWDStatus.sass';

type StatusProps = {
  workTypeList: WorkType;
  workType: StringUnion;
  workType2: StringUnion;
  workType3: StringUnion;
  policyRecordWork: StringUnion;
  workItemList?: WorkQueueItem[];
  workTypeRowNo: number;
};

const WorkTypeView = (props: StatusProps) => {
  const [awdStatusLabel, setAWDStatusLabel] = useState<HTMLLabelElement | null>();
  const dispatch = useDispatch();
  const {workType, workType2, workType3, workTypeList, workItemList} = props;

  useEffect(() => {
    if (isLoaded(workTypeList)) {
      if (props.workTypeRowNo === 0) dispatch(AWDStatusActions.changeWorkType(props.policyRecordWork.value));
      if (props.workTypeRowNo === 1) dispatch(AWDStatusActions.changeWorkType2(props.policyRecordWork.value));
      if (props.workTypeRowNo === 2) dispatch(AWDStatusActions.changeWorkType3(props.policyRecordWork.value));
    }
  }, [workTypeList, dispatch, props.policyRecordWork.value]);

  const changeWorkType = (workType: string, idx: number) => {
    if (idx == 0) {
      dispatch(AWDStatusActions.changeWorkType(workType));
    } else if (idx == 1) {
      dispatch(AWDStatusActions.changeWorkType2(workType));
    } else if (idx == 2) {
      dispatch(AWDStatusActions.changeWorkType3(workType));
    }
  };

  const getWorkTypeValue = (rowNo: number) => {
    if (rowNo == 0) {
      return workType.value;
    } else if (rowNo == 1) {
      return workType2.value;
    } else if (rowNo == 2) {
      return workType3.value;
    }
  };

  return (
    <>
      {matchWorkType({
        Loading: () => (
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-workType-label">
                Work Type + {props.workTypeRowNo}
              </InputLabel>
              <Select
                labelId="awdStatus-label-workType"
                name={`Work Type ${props.workTypeRowNo}`}
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-workType"
                value={getWorkTypeValue(props.workTypeRowNo)}
                onChange={e => changeWorkType(e.target.value as string, props.workTypeRowNo)}
                displayEmpty
              >
                <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              </Select>
              {isLoading(workTypeList) ? (
                <CircularProgress className="awdStatus-section__view-form-loading-icon" />
              ) : null}
            </FormControl>
          </Grid>
        ),
        Loaded: () => (
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-workType-label">
                Work Type
              </InputLabel>
              <Select
                labelId="awdStatus-label-workType"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-workType"
                name={`Work Type ${props.workTypeRowNo}`}
                value={getWorkTypeValue(props.workTypeRowNo)}
                onChange={e => changeWorkType(e.target.value as string, props.workTypeRowNo)}
                displayEmpty
              >
                {isLoaded(workTypeList) ? (
                  workTypeList.Data.map(rel => (
                    <MenuItem value={rel} key={rel}>
                      {rel}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">&nbsp;&nbsp;</MenuItem>
                )}
              </Select>
              {isLoading(workTypeList) ? (
                <CircularProgress className="awdStatus-section__view-form-loading-icon" />
              ) : null}
            </FormControl>
          </Grid>
        ),
        Unassigned: () => (
          <Grid item xs={12} md={3}>
            <FormControl variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-workType-label">
                Work Type
              </InputLabel>
              <Select
                labelId="awdStatus-label-workType"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-workType"
                value={workType.value}
                onChange={e => dispatch(AWDStatusActions.changeWorkType(e.target.value as string))}
                displayEmpty
              >
                <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        ),
        Error: () => (
          <Grid item xs={12} md={3}>
            <FormControl error variant="outlined" className="awdStatus-section__view-form-text-field">
              <InputLabel ref={setAWDStatusLabel} id="awdStatus-workType-label">
                Work Type
              </InputLabel>
              <Select
                labelId="awdStatus-label-workType"
                labelWidth={awdStatusLabel?.clientWidth}
                id="awdStatus-workType"
                value={workType.value}
                onChange={e => dispatch(AWDStatusActions.changeWorkType(e.target.value as string))}
                displayEmpty
              >
                <MenuItem value="">&nbsp;&nbsp;</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        ),
      })(workTypeList)}
    </>
  );
};

export default WorkTypeView;
